/**
 * This class provide window.usercentrics functions.
 */
import { UtilityService } from '../utility.service';
import { DataService } from './data.service';
export class TagLoggerService {
    private _utilityService: any;
    constructor(utilityService) {
        this._utilityService = utilityService;
    }

    static getOutputDataFromLocalstorage(blackListedTargets) {
        let ouputData = {
            sources: [],
            targets: [],
            mapper: []
        };
        let logs = DataService.getLocalStorage('mappedLog');
        if (logs) {
            logs = JSON.parse(logs);
            let updateOutputFromStorage = true;
            /**
             * If blacklisted targets are already in localstorage without *.{blacklisted}
             * then localstorage has older data so ignore localstorage and create data again
             */
            targetLoop: for (let i = 0; i < logs.targets.length; i++) {
                for (let j = 0; j < blackListedTargets.length; j++) {
                    if (
                        logs.targets[i].indexOf(blackListedTargets[j]) !== -1 &&
                        logs.targets[i] !== '*.' + blackListedTargets[j]
                    ) {
                        updateOutputFromStorage = false;
                        break targetLoop;
                    }
                }
            }
            if (updateOutputFromStorage) {
                ouputData = logs;
            }
        }

        return ouputData;
    }

    updateLog() {
        // targetes for which we do not need more than 1 entry
        const blackListedTargets = ['localhost', 'fls.doubleclick.net', 'ad.doubleclick.net'];
        this._utilityService.developmentLog('inside updateLog');
        const usercentricsLog = window.performance.getEntries();
        const ouputData = TagLoggerService.getOutputDataFromLocalstorage(blackListedTargets);
        let source = TagLoggerService.extractSubdomain(window.location.href);
        if (source.indexOf('/') === -1) {
            source = '/';
        } else {
            source = source.slice(source.indexOf('/'));
        }
        let sourceIndex = ouputData.sources.indexOf(source);
        if (sourceIndex === -1) {
            sourceIndex = ouputData.sources.length;
            ouputData.sources.push(source);
            ouputData.mapper.push([]);
        }
        ouputData.mapper[sourceIndex] = [];
        ouputData.targets.forEach(element => {
            ouputData.mapper[sourceIndex].push([1, 0, '']);
        });
        for (let i = 0; i < usercentricsLog.length; i++) {
            if (
                usercentricsLog[i].entryType === 'mark' ||
                usercentricsLog[i].entryType === 'measure' ||
                usercentricsLog[i].entryType === 'paint'
            ) {
                continue;
            }
            const url = usercentricsLog[i].name;
            let target = TagLoggerService.extractSubdomain(url);
            /**
             * If target is part of blacklistedDomain then update target to *.{blacklistedDomain}
             */
            let blackListedDomain = null;
            blackListedTargets.forEach(element => {
                if (target.indexOf(element) !== -1) {
                    blackListedDomain = element;
                }
            });
            if (blackListedDomain) {
                target = '*.' + blackListedDomain;
            }
            let targetIndex = ouputData.targets.indexOf(target);
            if (targetIndex === -1) {
                targetIndex = ouputData.targets.length;
                ouputData.targets.push(target);
                ouputData.mapper[sourceIndex][targetIndex] = [1, 0, ''];
            }
            ++ouputData.mapper[sourceIndex][targetIndex][0];
            ouputData.mapper[sourceIndex][targetIndex][1] = Math.round(
                (ouputData.mapper[sourceIndex][targetIndex][1] + usercentricsLog[i].duration) /
                    ouputData.mapper[sourceIndex][targetIndex][0]
            );
        }
        ouputData.targets.forEach((element, index) => {
            ouputData.mapper[sourceIndex][index][0] = ouputData.mapper[sourceIndex][index][0].toString();
            ouputData.mapper[sourceIndex][index][1] = ouputData.mapper[sourceIndex][index][1].toString();
        });

        DataService.storeToLocalStorage('mappedLog', JSON.stringify(ouputData));
        this.updateLogs(ouputData);
    }

    updateLogs(logs) {
        const origDomain = window.location.hostname;
        this._utilityService.developmentLog('inside updateLogs', logs);
        const self = this;
        const paramsToSave: any = {
            operationName: 'saveTagLoggerData',
            query: `mutation saveTagLoggerData($settingsId: String, $origin: String, $data: TagLoggerData)
					{
						saveTagLoggerData(settingsId: $settingsId, origin: $origin, data: $data) 
					}`,
            variables: {
                origin: origDomain,
                settingsId: this._utilityService.settingsService.settings.settingsId,
                data: logs
            }
        };
        this._utilityService.apiService.saveTagLoggerData(paramsToSave);
        /**
         * return this._utilityService.apiService.saveTagLoggerData(paramsToSave).then(
         * (response: any) => {
         * this._utilityService.developmentLog('logs are saved', response);
         * },
         * (error: any) => {
         * console.error('saveConsentsToServer: ', error);
         * }
         * );
         *
         */
    }

    static extractSubdomain(url) {
        let subDomain;
        if (url.indexOf('://') > -1) {
            subDomain = url.split('/')[2];
            if (url.split('/')[3]) {
                subDomain += '/' + url.split('/')[3];
            }
        } else {
            subDomain = url.split('/')[0];
            if (url.split('/')[1]) {
                subDomain += '/' + url.split('/')[1];
            }
        }

        // find & remove '?'
        subDomain = subDomain.split('?')[0];

        return subDomain;
    }
}
